module.exports = __webpack_public_path__ + "static/media/open-ended.6153d2f9.mp3";